/**
 * Created by calhosh on 9/13/2024
 */
import React from 'react';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';
import {EngagementStatus, reviewNoteRoutes} from '../../../util/uiconstants';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {
	IconoirHome,
	IconoirGroup,
	IconoirMap,
	IconoirPage,
	IconoirPageEdit,
	IconoirReportColumns
} from '@ey-xd/motif-icon';
import env from '../../../util/env';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import MotifTextLink from '@ey/motif-react-wrapper/TextLink';
import {
	IconoirCustomSmartAutomationProduct,
	IconoirCustomTaskList,
	IconoirCustomServiceGateway
} from '@ey/motif-react-wrapper/assets/icons/custom';

export function MenuIconOptions({
	engagement,
	configurations,
	engagements,
	displayLanguage,
	isAutomationHubEnabled,
	gateWayOptionsOpen,
	setGateWayOptionsOpen,
	selectedIcon,
	setSelectedIcon,
	handleButtonClick,
	quickLinks
}) {
	let menuOptions = [];
	const baseCanvasUrl = Utility.getCanvasBaseUrl(engagement, displayLanguage);
	let engagementArchived =
		engagement.engagementStatusId === EngagementStatus.Archived || engagement.isProfileComplete === false;

	const currentRoute = window.location.pathname.toLowerCase(),
		currentUrlSearch = window.location.search;
	const serviceRequestEnabled =
		!_.isEmpty(configurations?.features?.serviceGatewayBase) &&
		!getSDMFeatureRestricted(
			configurations?.features?.restrictedCountryIdsForSDM,
			configurations?.features?.validServiceLinesForSDM,
			engagement?.countryId,
			engagement?.serviceLineId,
			engagement?.subServiceLineId
		);

	const getServiceGatewayAndAutomation = () => {
		return (
			<MotifDropdown
				open={gateWayOptionsOpen}
				handleOnClose={() => {
					setGateWayOptionsOpen(false);
					setSelectedIcon(undefined);
				}}
				//closeOnOutsideClick={false}
				className="GateWayOptionsDropdown"
				trigger={
					<MotifButton
						key="serviceGatewayAutomation"
						aria-label="Click to go to service gateway and automation"
						type="button"
						variant="ghost"
						size="medium"
						title={labels.eyserviceGatewayAutomation}
						isSelected={selectedIcon === 'serviceGatewayAutomation'}
						className="motif-button-icon-only"
					>
						<MotifIcon
							onClick={() => {
								setGateWayOptionsOpen(!gateWayOptionsOpen);
								setSelectedIcon('serviceGatewayAutomation');
							}}
							src={IconoirCustomSmartAutomationProduct}
							size="24"
							title={labels.eyserviceGatewayAutomation}
						/>
					</MotifButton>
				}
				children={
					<>
						{serviceRequestEnabled && (
							<section className="ChildSection motif-body1-default-light">
								<MotifTextLink
									href={`${configurations?.features?.serviceGatewayBase}?engagementId=${engagement.engagementId}`}
									target={'_blank'}
									onClick={() => {
										setGateWayOptionsOpen(!gateWayOptionsOpen);
										setSelectedIcon(undefined);
									}}
								>
									<MotifIcon src={IconoirCustomServiceGateway} size="20" />
									<span className="SpanLableTxt">{labels.eyServiceGateway}</span>
								</MotifTextLink>
							</section>
						)}
						<section className="ChildSection motif-body1-default-light">
							<MotifTextLink
								href={Utility.getAutomationHubLink(baseCanvasUrl, engagement, engagements, isAutomationHubEnabled)}
								target={'_blank'}
								onClick={() => {
									setGateWayOptionsOpen(!gateWayOptionsOpen);
									setSelectedIcon(undefined);
								}}
							>
								<MotifIcon src={IconoirCustomSmartAutomationProduct} size="20" />
								<span className="SpanLableTxt">{labels.eyAutomation}</span>
							</MotifTextLink>
						</section>
					</>
				}
			/>
		);
	};

	const pushMaps = () => {
		return {
			key: 'maps',
			className: 'maps',
			url: '/dashboard/maps?engagementId=' + engagement.engagementId,
			title: labels.maps,
			children: (
				<MotifButton
					aria-label="Click to go to maps"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.maps}
					className="motif-button-icon-only"
					isSelected={selectedIcon === 'Maps' || currentRoute === '/dashboard/maps'}
					onClick={() => handleButtonClick('/dashboard/maps?engagementId=' + engagement.engagementId, 'maps')}
				>
					<NavLink to={'/dashboard/maps?engagementId=' + engagement.engagementId} title={labels.maps}>
						<MotifIcon src={IconoirMap} size="24" title={labels.maps} />
					</NavLink>
				</MotifButton>
			)
		};
	};

	const pushFinancialStatements = () => {
		return {
			key: 'financialStatements',
			className: 'financialStatements',
			url: '/financialstatements?engagementId=' + engagement.engagementId,
			title: labels.financialStatements,
			children: (
				<MotifButton
					aria-label="Click to go to financialStatements"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.financialStatements}
					isSelected={selectedIcon === 'FinancialStatements' || currentRoute === '/financialstatements'}
					className="motif-button-icon-only"
					onClick={() => {
						handleButtonClick('/financialstatements?engagementId=' + engagement.engagementId, 'financialStatements');
					}}
				>
					<NavLink
						to={'/financialstatements?engagementId=' + engagement.engagementId}
						title={labels.financialStatements}
					>
						<MotifIcon src={IconoirReportColumns} size="24" title={labels.financialStatements} />
					</NavLink>
				</MotifButton>
			)
		};
	};

	function getSDMFeatureRestricted(
		restrictedCountryIds,
		validServiceLines,
		countryId,
		engServiceLineId,
		engSubServiceLineId
	) {
		if (!(countryId > 0)) {
			return true;
		}

		if (_.some(restrictedCountryIds, (id) => id === -1 || id === countryId)) {
			/*if -1 value is available in list then disable at LDC level*/
			return true;
		}

		/*If serviceline and subserviceline combination matched then it should not be restricted.*/
		return !_.some(
			validServiceLines,
			({serviceLineId, subServiceLineId}) =>
				serviceLineId === engServiceLineId && subServiceLineId === engSubServiceLineId
		);
	}

	if (!engagementArchived) {
		menuOptions = [
			[
				{
					key: 'LandingPage',
					className: 'LandingPage',
					url: '/dashboard?engagementId=' + engagement.engagementId + '#myProgress',
					title: labels.navDashboard,
					children: (
						<MotifButton
							aria-label="Click to go to dashboard"
							type="button"
							variant="ghost"
							size="medium"
							title={labels.navDashboard}
							className="motif-button-icon-only"
							isSelected={
								selectedIcon === 'LandingPage' ||
								(currentRoute === '/dashboard' && !currentUrlSearch.includes('category=documents'))
							}
							onClick={() =>
								handleButtonClick('/dashboard?engagementId=' + engagement.engagementId + '#myProgress', 'LandingPage')
							}
						>
							<NavLink
								to={'/dashboard?engagementId=' + engagement.engagementId + '#myProgress'}
								title={labels.navDashboard}
							>
								<MotifIcon src={IconoirHome} size="24" title={labels.navDashboard} />
							</NavLink>
						</MotifButton>
					)
				}
			],
			[
				{
					key: 'TaskPage',
					className: 'TaskPage',
					url: '/tasks?engagementId=' + engagement.engagementId,
					title: labels.tasksPage,
					children: (
						<MotifButton
							aria-label="Click to go to tasks"
							type="button"
							variant="ghost"
							size="medium"
							title={labels.tasksPage}
							className="motif-button-icon-only"
							isSelected={selectedIcon === 'TaskPage' || currentRoute.includes('/tasks')}
							onClick={() => handleButtonClick('/tasks?engagementId=' + engagement.engagementId, 'TaskPage')}
						>
							<NavLink to={'/tasks?engagementId=' + engagement.engagementId} title={labels.tasksPage}>
								<MotifIcon src={IconoirCustomTaskList} size="24" title={labels.tasksPage} />
							</NavLink>
						</MotifButton>
					)
				},
				{
					key: 'DocumentsPage',
					className: 'DocumentsPage',
					url: '/dashboard?category=documents&engagementId=' + engagement.engagementId + '#engagementOverview',
					title: labels.documentsPage,
					children: (
						<MotifButton
							aria-label="Click to go to documents"
							type="button"
							variant="ghost"
							size="medium"
							title={labels.documentsPage}
							className="motif-button-icon-only"
							isSelected={
								selectedIcon === 'DocumentsPage' ||
								(currentRoute.includes('/dashboard') && currentUrlSearch.includes('category=documents'))
							}
							onClick={() =>
								handleButtonClick(
									'/dashboard?category=documents&engagementId=' + engagement.engagementId + '#engagementOverview',
									'DocumentsPage'
								)
							}
						>
							<NavLink
								to={'/dashboard?category=documents&engagementId=' + engagement.engagementId + '#engagementOverview'}
								title={labels.documentsPage}
							>
								<MotifIcon src={IconoirPage} size="24" title={labels.documentsPage} />
							</NavLink>
						</MotifButton>
					)
				},
				{
					key: 'ReviewNotesPage',
					className: 'ReviewNotesPage',
					url: env.getURL('hercules_web') + reviewNoteRoutes.reviewNoteHub + '?engagementId=' + engagement.engagementId,
					title: labels.navReviewnotes,
					children: (
						<MotifButton
							aria-label="Click to go to review notes"
							type="button"
							variant="ghost"
							size="medium"
							title={labels.navReviewnotes}
							className="motif-button-icon-only"
							isSelected={selectedIcon === 'ReviewNotesPage' || currentRoute.includes('/reviewnotes/')}
							onClick={() =>
								handleButtonClick(
									reviewNoteRoutes.reviewNoteHub + '?engagementId=' + engagement.engagementId,
									'ReviewNotesPage'
								)
							}
						>
							<NavLink
								to={reviewNoteRoutes.reviewNoteHub + '?engagementId=' + engagement.engagementId}
								title={labels.navReviewnotes}
							>
								<MotifIcon src={IconoirPageEdit} size="24" title={labels.navReviewnotes} />
							</NavLink>
						</MotifButton>
					)
				},
				{
					key: 'CollaborationPage',
					className: 'CollaborationPage',
					url: env.getURL('hercules_web') + '/collaborationv2?engagementId=' + engagement.engagementId,
					title: labels.collaborationPage,
					children: (
						<MotifButton
							aria-label="Click to go to collaboration"
							type="button"
							variant="ghost"
							size="medium"
							title={labels.collaborationPage}
							className="motif-button-icon-only"
							isSelected={selectedIcon === 'CollaborationPage' || currentRoute.includes('/collaboration')}
							onClick={() =>
								handleButtonClick('/collaborationv2?engagementId=' + engagement.engagementId, 'CollaborationPage')
							}
						>
							<NavLink to={'/collaborationv2?engagementId=' + engagement.engagementId} title={labels.collaborationPage}>
								<MotifIcon src={IconoirGroup} size="24" title={labels.collaborationPage} />
							</NavLink>
						</MotifButton>
					)
				},
				{
					title: labels.serviceGatewayAutomation,
					children: getServiceGatewayAndAutomation()
				}
			]
		];
	}

	if (quickLinks?.defaultEngagementMapId) {
		if (menuOptions.length > 0 && Array.isArray(menuOptions[0])) {
			menuOptions[0].push(pushMaps());
		} else {
			menuOptions.push(pushMaps());
		}
	}

	if (quickLinks?.defaultTrialBalanceId !== null || engagement?.isHelixDataImportAllowed === true) {
		if (menuOptions.length > 0 && Array.isArray(menuOptions[0])) {
			menuOptions[0].push(pushFinancialStatements());
		} else {
			menuOptions.push(pushFinancialStatements());
		}
	}

	return menuOptions;
}
